import { ListConfigurationModel, ListModel } from '../models/ListModel';
import { normalizeCategory } from '../../category/normalizers/CategoryNormalizer';
import { VideoModel } from '../../video/models/VideoModel';
import { ArticleModel } from '../../article/models/ArticleModel';
import { normalizeArticle, normalizePartialArticle } from '../../article/normalizers/ArticleNormalizer';
import { normalizeVideo } from '../../video/normalizers/VideoNormalizer';
import { ArticlePartialModel } from '../../article/models/ArticlePartialModel';

enum ResourceTypes {
    ARTICLE = 'ARTICLE',
    VIDEO = 'VIDEO',
}

export const normalizeLists = (response: any): ListModel[] => {
    if (response) {
        return response.map((item: any) => normalizeList(item));
    }

    return [];
};

export const normalizeHomepageLists = (response: any): ListModel[] => {
    if (response) {
        return response.map((item: any) => normalizePartialArticleList(item));
    }

    return [];
};

export const normalizePartialArticleList = (response: any): ListModel => {
    return {
        id: response?.id ? response.id : null,
        entityType: response?.entity_type ? response.entity_type : null,
        title: response?.title ? response.title : null,
        slug: response?.slug ? response.slug : null,
        status: response?.status ? response.status : null,
        weight: response?.weight ? response.weight : null,
        createdAt: response?.created_at ? response.created_at : null,
        updatedAt: response?.updated_at ? response.updated_at : null,
        contentType: response?.content_type ? response.content_type : null,
        configuration: response?.configuration ? normalizeListConfiguration(response.configuration) : null,
        items: response?.items && response.items.length > 0 ? normalizePartialArticleListItems(response.items) : [],
    };
};

export const normalizeList = (response: any): ListModel => {
    return {
        id: response?.id ? response.id : null,
        entityType: response?.entity_type ? response.entity_type : null,
        title: response?.title ? response.title : null,
        slug: response?.slug ? response.slug : null,
        status: response?.status ? response.status : null,
        weight: response?.weight ? response.weight : null,
        createdAt: response?.created_at ? response.created_at : null,
        updatedAt: response?.updated_at ? response.updated_at : null,
        contentType: response?.content_type ? response.content_type : null,
        configuration: response?.configuration ? normalizeListConfiguration(response.configuration) : null,
        items: response?.items && response.items.length > 0 ? normalizeListItems(response.items) : [],
    };
};

const normalizeListConfiguration = (response: any): ListConfigurationModel | null => {
    if (response) {
        return {
            maxItems: response?.maxItems ? response.maxItems : null,
            minItems: response?.minItems ? response.minItems : null,
            category: response?.category ? normalizeCategory(response.category) : null,
        };
    }

    return null;
};

const normalizeListItems = (response: any[]): (ArticleModel | VideoModel | null)[] => {
    if (response.length > 0) {
        return response
            .map((item: any) => normalizeListItem(item))
            .filter((item: ArticleModel | VideoModel | null) => item !== null);
    }

    return [];
};

const normalizePartialArticleListItems = (response: any[]): ArticlePartialModel[] => {
    if (response.length > 0) {
        return response.map((item: any) => normalizePartialArticle(item.data));
    }
    return [];
};

const normalizeListItem = (item: any): ArticleModel | VideoModel | null => {
    switch (item.type) {
        case ResourceTypes.ARTICLE: {
            return normalizeArticle(item.data);
        }
        case ResourceTypes.VIDEO: {
            return normalizeVideo(item.data);
        }
        default: {
            return null;
        }
    }
};
